import { render, staticRenderFns } from "./SalePointTypeList.vue?vue&type=template&id=2b7d1b32"
import script from "./SalePointTypeList.vue?vue&type=script&lang=js"
export * from "./SalePointTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports